export default __webpack_public_path__ + "media/images/after_day-81b334b414fb6d7dcc4a77e3c936cce2.svg";